







import { Component, Vue, Watch } from 'vue-property-decorator'
import Layout from '@/components/public/Layout.vue'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import router from './router'
const appStore = namespace('app')
@Component({
  components: {
    Layout
  }
})
export default class App extends Vue {
  private checkedTheme: string = 'theme-one'
  @appStore.State((state) => state.isLogin) private isLogin: boolean
  @appStore.Action('getConfig') private getConfig!: Function
  @Watch('$route')
  routechange(to: any, from: any) {
    if (this.isLogin) {
      this['$router'].push({ path: to.path }).catch(() => {
        return
      })
    } else {
      this['$router'].push({ path: '/' }).catch(() => {
        return
      })
    }
  }
  created(): void {
    this.getConfig()
    if (sessionStorage.getItem('store')) {
      this['$store'].replaceState(
        Object.assign(
          {},
          this['$store'].state,
          JSON.parse(sessionStorage.getItem('store') || '')
        )
      )
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this['$store'].state.app))
    })
  }
}
